<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow" :gutter="16">
                <Col span="24">
                    <search-card
                        :form="mainTable.searchForm"
                        :table-load-event="getSaleStatList"
                        :table-search="mainTable.tableSearch"
                        :colSpan="4"
                        :searchBtnColSpan="4"
                    />
                </Col>
            </Row>
        </transition>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">苗场定金统计</span>
                            <span style="margin-left: 10px">统计时间:</span>
                            <DatePicker
                                type="daterange"
                                v-model="selectDates"
                                size="small"
                                transfer
                                :clearable="false"
                                placement="bottom-end"
                                placeholder="选择期初和期末时间"
                                style="margin-left: 4px; width: 200px"
                                @on-change="getSaleStatList"
                            ></DatePicker>
                            <RadioGroup
                                v-model="groupBy"
                                style="margin-left: 20px"
                                type="button"
                                size="small"
                                @on-change="getSaleStatList"
                            >
                                <Radio label="seedFarm">
                                    <span>苗场</span>
                                </Radio>
                            </RadioGroup>
                        </div>
                        <div class="right-bar">
                            <Button
                                type="info"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-send"
                                @click="onExport()"
                                >导出</Button
                            >
                            <Button
                                type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="
                                    mainTable.sarchCardShow =
                                        !mainTable.sarchCardShow
                                "
                                >搜索</Button
                            >
                        </div>
                    </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        :columns="mainTable.columns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :extHeight="-50"
                        :table-load-event="getSaleStatList"
                        :showPage="false"
                    />
                </Col>
            </Row>
        </Card>
        <SeedfarmDepositStatModal ref="seedfarmDepositStatModal" />
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/pagination-table/pagination-table.vue";
import { dateTimeRender, dateRender } from "@/libs/tableRowTimeRender";
import { numberToFixed, number2ThousandsFormat } from "@/components/number-input/display-format";
import { getThisMonthStart, getTodayDateString } from "@/libs/logic";
import { getSeedFarmDepositStatList, getSeedFarmDepositStatSqlList, getSeedFarmDepositStatSqlDetail } from "@/api/modules/sale-management/sale-stat";
import { getRegionCascade } from "@/api/modules/system-management/region-management";
import { DOWNLOAD_SERVER } from "@/api/modules/files";
import SeedfarmDepositStatModal from "./seedfarm-deposit-stat-modal.vue";
import excel from "@/libs/excel";
export default {
    name: "seedfarm-deposit-stat-list",
    components: {
        StandPaginationTable,
        SearchCard,
        SeedfarmDepositStatModal
    },
    data() {
        return {
            // 日期选择和分组选项
            selectDates: [],
            groupBy: "seedFarm",

            // 主表格配置
            mainTable: {
                columns: this.createTableColumns(),
                data: [],
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                loading: false,
                searchForm: [
                    {
                        label: "苗场",
                        type: "Input",
                        value: "",
                        name: "concat(sf.seedFarmCode, sf.seedFarmName)",
                        sql: "like"
                    }
                ]
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        getTodayDateString,
        getThisMonthStart,

        // ==================== 表格配置相关 ====================

        /**
         * 创建表格列配置
         */
        createTableColumns() {
            return [
                {
                    title: "苗场编号",
                    key: "seedFarmCode",
                    align: "center",
                    width: 120,
                    excel: true
                },
                {
                    title: "苗场名称",
                    key: "seedFarmName",
                    align: "center",
                    width: 150,
                    excel: true
                },
                {
                    title: "期初定金",
                    key: "Beginning",
                    align: "center",
                    width: 120,
                    render: this.createMoneyRender("Beginning"),
                    excel: true
                },
                {
                    title: "收定金",
                    key: "DepositInSum",
                    align: "center",
                    width: 120,
                    render: this.createMoneyRender("DepositInSum"),
                    excel: true
                },
                {
                    title: "退定金",
                    key: "DepositConsumeSum",
                    align: "center",
                    width: 120,
                    render: this.createMoneyRender("DepositConsumeSum"),
                    excel: true
                },
                {
                    title: "期末定金",
                    key: "Ending",
                    align: "center",
                    width: 120,
                    render: this.createMoneyRender("Ending"),
                    excel: true
                },
                {
                    title: "操作",
                    key: "action",
                    align: "center",
                    width: 120,
                    render: this.createActionRender(),
                    excel: true
                }
            ];
        },

        /**
         * 创建金额列渲染函数
         */
        createMoneyRender(key) {
            return (h, params) => {
                const value = params.row[key] || 0;
                return h("div", {
                    class: "money-cell"
                }, [
                    h("span", {
                        class: "money-text"
                    }, number2ThousandsFormat(value, 2, "￥"))
                ]);
            };
        },

        /**
         * 创建操作列渲染函数
         */
        createActionRender() {
            return (h, params) => {
                if (params.row.action === -1) {
                    return h("div", { class: "action-cell" }, "");
                }

                return h("div", { class: "action-cell" }, [
                    h("Button", {
                        props: {
                            type: "text",
                            size: "small",
                            icon: "ios-search"
                        },
                        on: {
                            click: () => this.showDetail(params.row.seedFarmUuid)
                        }
                    }, "查看明细")
                ]);
            };
        },

        // ==================== 业务逻辑相关 ====================

        /**
         * 初始化页面
         */
        init() {
            const beginDate = this.getThisMonthStart();
            const endDate = this.getTodayDateString();
            this.selectDates = [beginDate, endDate];
            this.getSaleStatList();
        },

        /**
         * 获取统计数据列表
         * @param {boolean} reset - 是否重置搜索条件
         */
        getSaleStatList(reset = false) {
            this.mainTable.loading = true;

            // 重置搜索条件
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            // 设置查询参数
            this.setupSearchParams();

            // 发起请求
            this.fetchSaleStatData();
        },

        /**
         * 设置查询参数
         */
        setupSearchParams() {
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.tableSearch.needExport = 0;
            this.setDateTimeFilter();
        },

        /**
         * 设置日期过滤条件
         */
        setDateTimeFilter() {
            if (!this.selectDates || this.selectDates.length !== 2) {
                console.warn("日期范围不完整，请选择开始和结束日期");
                return;
            }

            this.mainTable.tableSearch.filters.enable = true;
            search.globalAddFilterConditionKey(
                this.mainTable.tableSearch,
                "beginDate",
                "eq",
                this.selectDates[0],
                true
            );
            search.globalAddFilterConditionKey(
                this.mainTable.tableSearch,
                "endDate",
                "eq",
                this.selectDates[1],
                true
            );
        },

        /**
         * 获取统计数据
         */
        async fetchSaleStatData() {
            try {
                const res = await getSeedFarmDepositStatSqlList(this.mainTable.tableSearch);

                if (res.code === 0) {
                    this.mainTable.data = res.data.listCombine || [];
                } else {
                    this.$Message.error(`获取数据失败: ${res.message || '未知错误'}`);
                }
            } catch (error) {
                console.error("获取统计数据失败:", error);
                this.$Message.error("获取统计数据失败，请稍后重试");
            } finally {
                this.mainTable.loading = false;
            }
        },

        /**
         * 显示详情弹窗
         * @param {string} uuid - 苗场UUID
         */
        showDetail(uuid) {
            if (!uuid) {
                this.$Message.warning("无法获取苗场信息");
                return;
            }

            this.$refs.seedfarmDepositStatModal.showModal(
                uuid,
                this.selectDates,
                "seedFarm"
            );
        },

        /**
         * 导出数据
         */
        onExport() {
            // 检查是否有数据可导出
            if (!this.mainTable.data || this.mainTable.data.length === 0) {
                this.$Message.warning('暂无数据可导出');
                return;
            }

            const exportSearch = this.prepareExportSearch();

            this.mainTable.loading = true;
            getSeedFarmDepositStatSqlList(exportSearch)
                .then(this.handleExportResponse)
                .catch(this.handleExportError)
                .finally(() => {
                    this.mainTable.loading = false;
                });
        },
        prepareExportSearch() {
            const exportSearch = search.deepClone(this.mainTable.tableSearch);

            // 禁用分页以获取全部数据
            exportSearch.limit.enable = false;

            // 启用Excel导出
            exportSearch.excelExport.enable = true;

            // 获取表格列定义
            const tableColumns = this.createTableColumns();

            // 只导出标记为excel的列
            exportSearch.excelExport.columns2 = tableColumns
                .filter((col) => col.excel)
                .map((col) => ({
                    key: col.key,
                    title: col.title
                }));

            // 确保至少有一列可导出
            if (exportSearch.excelExport.columns2.length === 0) {
                console.warn('没有可导出的列，将导出所有列');
                exportSearch.excelExport.columns2 = tableColumns
                    .map((col) => ({
                        key: col.key,
                        title: col.title
                    }));
            }

            return exportSearch;
        },
        /**
         * 处理导出响应
         */
        handleExportResponse(res) {
            if (res.code === 0 && res.data && res.data.exportFileName2) {
                try {
                    const url = DOWNLOAD_SERVER + res.data.exportFileName2;
                    this.$downLoadFile(url);
                    this.$Message.success('导出成功，文件正在下载...');
                } catch (downloadError) {
                    console.error('文件下载失败:', downloadError);
                    this.$Message.error('文件下载失败，请稍后重试');
                }
            } else {
                const errorMsg = res.message || '导出失败，服务器返回异常';
                console.error('导出响应异常:', res);
                this.$Message.error(errorMsg);
            }
        },
        /**
         * 处理导出错误
         */
        handleExportError(error) {
            console.error('导出种子农场押金统计列表失败:', error);

            let errorMessage = '导出失败，请稍后重试';

            // 根据不同的错误类型提供更具体的提示
            if (error.response) {
                // 服务器响应了错误状态码
                const status = error.response.status;
                if (status === 401) {
                    errorMessage = '身份验证失败，请重新登录';
                } else if (status === 403) {
                    errorMessage = '权限不足，无法执行导出操作';
                } else if (status === 500) {
                    errorMessage = '服务器内部错误，请联系管理员';
                } else if (status === 504) {
                    errorMessage = '请求超时，请稍后重试或联系管理员';
                }
            } else if (error.request) {
                // 请求发出但没有收到响应
                errorMessage = '网络连接失败，请检查网络后重试';
            }

            this.$Message.error(errorMessage);
        },
    }
};
</script>

<style scoped>
/* ==================== 表格样式 ==================== */

.global-tool-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding: 0 8px;
}

.left-bar {
    display: flex;
    align-items: center;
    gap: 10px;
}

.left-bar .title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.right-bar {
    display: flex;
    gap: 8px;
}

.btns {
    min-width: 70px;
}

/* ==================== 表格单元格样式 ==================== */

.money-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 8px;
}

.money-text {
    font-family: 'Consolas', 'Monaco', monospace;
    font-weight: 600;
    color: #e74c3c;
    font-size: 13px;
}

.action-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
}

/* ==================== 响应式设计 ==================== */

@media (max-width: 768px) {
    .global-tool-bar {
        flex-direction: column;
        gap: 12px;
        align-items: stretch;
    }

    .left-bar {
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
    }

    .right-bar {
        justify-content: center;
    }
}

/* ==================== 过渡动画 ==================== */

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
